import { render, staticRenderFns } from "./FrameInfo.vue?vue&type=template&id=57761e66"
import script from "./FrameInfo.vue?vue&type=script&lang=js"
export * from "./FrameInfo.vue?vue&type=script&lang=js"
import style0 from "./FrameInfo.vue?vue&type=style&index=0&id=57761e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports